import { socialConfig } from '../socialConfig'
import './team-cards.css'

// Founder cards: photo bleeding to the card edge, then role, name, the full
// bio and labelled profile links. Shared by the homepage and /team.

// Founder portraits are multi-MB Cloudinary PNGs saved as http:// URLs. Ask
// Cloudinary for a resized, auto-format (WebP/AVIF) copy over https instead.
// Any other host is passed through untouched.
function photoSources(url) {
  if (!url) return null
  const secure = url.replace(/^http:\/\//i, 'https://')
  if (!/^https:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\//i.test(secure)) return { src: secure }
  const at = (w) => secure.replace('/image/upload/', `/image/upload/f_auto,q_auto,c_limit,w_${w}/`)
  return { src: at(640), srcSet: `${at(420)} 420w, ${at(640)} 640w, ${at(960)} 960w` }
}

function LeaderCard({ leader }) {
  const photo = photoSources(leader.image_url)
  const links = socialConfig.filter(({ key }) => leader[key])

  return (
    <article className="tc-leader">
      {photo ? (
        <div className="tc-leader-photo">
          <img
            src={photo.src}
            srcSet={photo.srcSet}
            sizes="(max-width: 720px) 92vw, 15rem"
            alt={leader.name}
            loading="lazy"
            decoding="async"
          />
        </div>
      ) : null}
      <div className="tc-leader-body">
        <p className="tc-leader-role">{leader.role}</p>
        <h3 className="tc-leader-name">{leader.name}</h3>
        {leader.description ? <p className="tc-leader-bio">{leader.description}</p> : null}
        {links.length ? (
          <ul className="tc-leader-links" aria-label={`${leader.name} online`}>
            {links.map(({ key, label, svg }) => (
              <li key={key}>
                <a
                  className={`tc-leader-link brand-${key.replace('_url', '')}`}
                  href={leader[key]}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {svg}
                  <span>{label}</span>
                </a>
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </article>
  )
}

export default function LeaderCards({ leaders }) {
  if (!leaders?.length) return null
  return (
    <div className="tc-leaders">
      {leaders.map((leader) => (
        <LeaderCard key={leader.id || leader.name} leader={leader} />
      ))}
    </div>
  )
}
